export const COMPANY_FACEBOOK_PAGE = 'https://www.facebook.com/insiderfinance.io';
export const COMPANY_TWITTER = 'https://twitter.com/InsiderFinancex';
export const COMPANY_EMAIL = 'team@insiderfinance.io';
export const COMPANY_EMAIL_LINK = `mailto:${COMPANY_EMAIL}`;
export const COMPANY_INSTAGRAM = 'https://www.instagram.com/insiderfinance.io';
export const COMPANY_LINKEDIN = 'https://www.linkedin.com/company/insiderfinance';
